// Modal mínimo para registrar una INTERACCIÓN sin alarma (Blocker 3). No es CRM ni Parte de Guardia.
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export default function RegistrarContactoModal({ open, onOpenChange, onConfirm, submitting }) {
  const [quien, setQuien] = useState("");
  const [relacion, setRelacion] = useState("");
  const [motivo, setMotivo] = useState("");
  const [nota, setNota] = useState("");
  const puede = quien.trim() && motivo.trim();

  const submit = async () => {
    if (!puede) return;
    await onConfirm({ quien: quien.trim(), relacion: relacion.trim(), motivo: motivo.trim(), nota: nota.trim() });
    setQuien(""); setRelacion(""); setMotivo(""); setNota("");
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="registrar-contacto-modal" className="sm:max-w-md">
        <DialogHeader><DialogTitle>Registrar contacto</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div>
            <Label className="text-xs">¿Quién llamó / contactó? *</Label>
            <Input data-testid="contacto-quien" value={quien} onChange={(e) => setQuien(e.target.value)} placeholder="Ej. Hijo (Ramón)" className="mt-1 rounded-lg" />
          </div>
          <div>
            <Label className="text-xs">Relación / descripción</Label>
            <Input data-testid="contacto-relacion" value={relacion} onChange={(e) => setRelacion(e.target.value)} placeholder="Ej. Hija, vecino, cuidadora" className="mt-1 rounded-lg" />
          </div>
          <div>
            <Label className="text-xs">Motivo / pregunta *</Label>
            <Input data-testid="contacto-motivo" value={motivo} onChange={(e) => setMotivo(e.target.value)} placeholder="Ej. ¿Saben si ha pasado algo?" className="mt-1 rounded-lg" />
          </div>
          <div>
            <Label className="text-xs">¿Qué se informó / hizo?</Label>
            <Textarea data-testid="contacto-nota" value={nota} onChange={(e) => setNota(e.target.value)} rows={2} className="mt-1 rounded-lg" />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Cancelar</Button>
          <Button data-testid="contacto-guardar" onClick={submit} disabled={!puede || submitting} className="bg-[#01CBE3] text-[#012472] hover:bg-[#01B5CB]">Guardar</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
